import {Component} from '@angular/core';


@Component({
    selector: 'app-lcl-containers-management',
    templateUrl: './lcl-containers-management.component.html',
    styleUrls: ['./lcl-containers-management.component.scss']
})
export class LclContainersManagementComponent {}
